<div class="modal fade">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Projeções Perdidas
                </h4> 
                <h6 class="modal-subtitle">
                    Informe o motivo e justificativa das perdas das projeções deste cliente
                </h6>                                              
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div *ngIf="entity"> 
                        <div class="row">
                            <div class="form-group col-12">
                                <label class="col-form-label">Cliente</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">{{entity.codigoIntegracaoErpCliente}}</span>
                                    </div>
                                    <input type="text" class="form-control" [value]="entity.nomeCliente | clienteNome: entity.nomeFantasiaCliente:null:entity.tipoPessoa" disabled="disabled" readonly="readonly">
                                </div>                                
                            </div>
                        </div>
                        <div class="row" *ngIf="!isRepresentante">
                            <div class="form-group col-12">
                                <label class="col-form-label">Representante</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">{{entity?.codigoIntegracaoErpRepresentante}}</span>
                                    </div>
                                    <input type="text" class="form-control" [value]="entity.nomeRepresentante | representanteNome: entity.nomeFantasiaRepresentante" disabled="disabled" readonly="readonly">
                                </div>                                
                            </div>
                        </div>
                        
                        <div class="card card-classificacoes">
                            <div class="card-header">
                                <div class="card-header-title">
                                    <h6 class="card-title mb-0">Classificacoes</h6>
                                </div>
                            </div>

                            <div class="card-body" *ngIf="isLoadingClassificacoes">
                                <p class="text-center m-0">
                                    <i class='fas fa-spinner fa-pulse'></i> Carregando os segmentos
                                </p>
                            </div>
                        
                            <div class="card-body" *ngIf="isLoadedClassificacoes && (!classificacoes || classificacoes.length === 0)">
                                <p class="text-center m-0">
                                    Nenhum segmento
                                </p>    
                            </div>

                            <div class="table-responsive" *ngIf="isLoadedClassificacoes && classificacoes?.length > 0">
                                <table class="table table-striped table-hover table-bordered table-cliente-analise-mercado-classificacao">
                                    <thead>
                                        <tr>
                                            <th class="col-nome col-sticky row-span-2" rowspan="2"></th>
                                            <th class="col-status text-center row-span-2" rowspan="2">Status<br/>Projetado</th>                               
                                            <th class="col-quantidade text-center" colspan="2" *ngIf="configEmpresa?.controleQuantidade">Quantidade</th>
                                            <th class="col-peso text-center" colspan="2" *ngIf="configEmpresa?.controlePeso">Peso</th>
                                            <th class="col-valor text-center row-span-2" rowspan="2" *ngIf="configEmpresa?.controleValor">Valor</th>
                                        </tr>
                                        <tr>                               
                                            <!-- Quantidade -->
                                            <ng-template [ngIf]="configEmpresa?.controleQuantidade">
                                                <th class="col-quantidade col-valor-unitario text-right">Preço Médio</th>
                                                <th class="col-quantidade col-quantidade-projetada text-right">Projetada</th>
                                            </ng-template>
            
                                            <!-- Peso -->
                                            <ng-template [ngIf]="configEmpresa?.controlePeso">
                                                <th class="col-peso col-valor-unitario text-right">Preço Médio</th>
                                                <th class="col-peso col-peso-projetado text-right">Projetado</th>
                                            </ng-template>
                                        </tr>                                    
                                    </thead>
    
                                    <tbody>
                                        <tr *ngFor="let entityClassificacao of classificacoes">
                                            <td class="col-nome col-sticky" [title]="entityClassificacao.classificacoesNome">
                                                {{entityClassificacao.classificacoesNome}}
                                            </td>
                                            <td class="col-status col-status-projetado text-center">
                                                <sgt-cliente-analise-mercado-status-projetado-badge-pill
                                                    [statusProjetado]="entityClassificacao.statusProjetado">
                                                </sgt-cliente-analise-mercado-status-projetado-badge-pill>
                                            </td>
    
                                            <!-- Quantidade -->
                                            <ng-template [ngIf]="configEmpresa?.controleQuantidade">
                                                <td class="col-quantidade col-valor-unitario text-right">
                                                    {{entityClassificacao.quantidadeProjetadaValorUnitario | decimalFormat: 1:2:2}}
                                                </td>
                                                <td class="col-quantidade col-quantidade-projetada text-right">
                                                    {{entityClassificacao.quantidadeProjetada | decimalFormat: 1:0:0}}
                                                </td>
                                            </ng-template> 
                                            
                                            <!-- Peso -->
                                            <ng-template [ngIf]="configEmpresa?.controlePeso">
                                                <td class="col-peso col-valor-unitario text-right">
                                                    {{entityClassificacao.pesoProjetadoValorUnitario | decimalFormat: 1:2:2}}
                                                </td>
                                                <td class="col-peso col-peso-projetado text-right">
                                                    {{entityClassificacao.pesoProjetado | decimalFormat: 1:0:0}}
                                                </td>                                                                       
                                            </ng-template>
                                            
                                            <ng-template [ngIf]="configEmpresa?.controleValor">
                                                <td class="col-valor col-valor-projetado text-right">
                                                    {{entityClassificacao.valorProjetado | decimalFormat: 1:0:0}}
                                                </td>
                                            </ng-template>
                                        </tr>
                                    </tbody>                                
                                </table>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-12">
                                <label for="motivoPerdaProjetadoUpdate" class="col-form-label">Motivo</label>
                                <select class="form-control" name="motivoPerdaProjetadoUpdate" id="motivoPerdaProjetadoUpdate" 
                                    [ngModel]="entity.entityUpdatePerda.idMotivoPerdaProjetado || ''" (ngModelChange)="onChangeMotivoPerda($event ? $event : null)"
                                    #motivoPerdaProjetadoUpdate="ngModel" required="required">>
                                    <option value="">Selecione o motivo...</option>
                                    <option *ngFor="let motivo of motivosPerdas" [ngValue]="motivo.id">{{motivo.nome}}</option>
                                </select>
                                <sgt-form-control-error
                                    *ngIf="motivoPerdaProjetadoUpdate.errors && motivoPerdaProjetadoUpdate.errors.required && motivoPerdaProjetadoUpdate.dirty"
                                    msgError="O motivo é obrigatório">
                                </sgt-form-control-error>                                    
                            </div>
                        </div>                                      
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="justificativaPerdaProjetadoUpdate" class="col-form-label">Justificativa</label>
                                <textarea class="form-control" [(ngModel)]="entity.entityUpdatePerda.justificativaPerdaProjetado" name="justificativaPerdaProjetadoUpdate" id="justificativaPerdaProjetadoUpdate" 
                                    #justificativaPerdaProjetadoUpdate="ngModel" rows="5" required="required" minlength="15">
                                </textarea>
                                <sgt-form-control-error
                                    *ngIf="justificativaPerdaProjetadoUpdate.errors && justificativaPerdaProjetadoUpdate.errors.required && justificativaPerdaProjetadoUpdate.dirty"
                                    msgError="A justificativa é obrigatória">
                                </sgt-form-control-error>
                                <sgt-form-control-error
                                    *ngIf="justificativaPerdaProjetadoUpdate.errors && justificativaPerdaProjetadoUpdate.errors.minlength"
                                    msgError="A justificativa deve ter no mínimo 15 caracteres">
                                </sgt-form-control-error>                                                                                               
                            </div>
                        </div>
                    </div>
                </form>                
            </div>
            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="cancelClick()">
                    Cancelar
                </button>       
                <button type="button" class="btn btn-danger" [disabled]="!form.valid" (click)="update()" id="btnClienteAnaliseMercadoProjecaoUpdatePerdida">
                    {{editMode ? 'Atualizar Perda' : 'Confirmar Perda'}}
                </button>                                
            </div>            
        </div>
    </div>
</div>